import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment.local';
import { ModeService } from '../mode/mode.service';

export const tenantHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const mode = inject(ModeService);
  const base = environment.apiBaseUrl.replace(/\/$/, '');

  if (!req.url.startsWith(base)) {
    return next(req);
  }

  const subdomain = mode.subdomain();
  if (subdomain === null) {
    return next(req);
  }

  return next(
    req.clone({ setHeaders: { 'X-Tenant-Subdomain': subdomain } }),
  );
};
